import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeOrderCloseModal, orderReset, orderClose, openOpenOrders } from '../actions/index';
import { Modal } from 'react-bootstrap';

class ModalOrderClose extends Component {

  // Close the modal and possibly the order
  handleOrderClose = closeOrder => {
    if (closeOrder) {
      // Close the order
      this.props.orderClose(this.props.modals.modalOrderID).then( () => {
        // Reset the new order page and close the modal
        this.props.orderReset();
        this.props.closeOrderCloseModal();
      });
    } else {
      // Close the modal and redirect to the open orders page
      this.props.closeOrderCloseModal();
      this.props.openOpenOrders();
    }
  }

  // Return a string of payment types used for the order
  printPaymentTypes = () => {
    // Translate the stored payment types with a version that is for printing on screen
    let printTypes = { "CASH":"Cash", "DEBIT":"Debit", "GIFT CARD":"Gift Card", "VISA":"Visa", "MASTERCARD":"Mastercard", "AMEX":"Amex"};

    // Return the payment types as string
    if (this.props.modals.modalOrderID !== '') {
      let payments = Object.values(this.props.orders[this.props.modals.modalOrderID].payments);
      return payments.map(function(payment) {
        return printTypes[payment.type];
      }).join(", ");
    }
  }

  render() {
    let grandtotal = 0, change = 0;
    if (this.props.modals.modalOrderID !== '') {
      grandtotal = this.props.orders[this.props.modals.modalOrderID].grandtotal;
      change = this.props.orders[this.props.modals.modalOrderID].change;
    }

    return(
      <Modal show={this.props.modals.showOrderCloseModal} onHide={() => this.handleOrderClose(false)}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <div className="center-text">
            <div>
              <span className="h1 text-center">Total ${Math.abs(grandtotal).toFixed(2)}</span>
            </div>
            <br />
            <span className="text-center">This order has been marked as paid using {this.printPaymentTypes()}.</span>
            <br />
            <br />
            <span className="h3 text-center">Change Due</span>
            <br />
            <span className="h2 text-center"><b>${change.toFixed(2)}</b></span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={() => this.handleOrderClose(false)}>OK</button>&nbsp;
          <button type="button" className="btn btn-primary" onClick={() => this.handleOrderClose(true)}>OK + CLOSE</button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps({ modals, orders }) {
  return { modals, orders };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { closeOrderCloseModal, orderReset, orderClose, openOpenOrders }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalOrderClose);



// WEBPACK FOOTER //
// ./src/containers/modal_order_close.js